
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256.7 1.1c-93.4 0-169.3 76-169.3 169.3s76 169.3 169.3 169.3S426 263.8 426 170.4 350 1.1 256.7 1.1zm125.9 249.5c-17-8.1-38.4-14.3-62.5-18.2 2.6-16.4 4.2-33.9 4.6-51.9h81c-1.8 25.6-10 49.6-23.1 70.1zm-125.9 64.6c-10.7 0-22.6-14.5-31.7-38.8-3.1-8.2-5.8-17.2-8-26.9 12.8-1.3 26.1-2 39.7-2s26.9.7 39.7 2c-2.2 9.7-4.9 18.7-8 26.9-9.2 24.3-21 38.8-31.7 38.8zm0-87.7c-15 0-29.6.8-43.6 2.2-2.5-15.5-4-32.1-4.4-49.3h95.9c-.4 17.2-1.9 33.8-4.4 49.3-13.9-1.5-28.5-2.2-43.5-2.2zm-149-47h81c.4 18 2 35.5 4.6 51.9-24.1 3.9-45.5 10.1-62.5 18.2-13.2-20.5-21.4-44.5-23.1-70.1zm23-90.2c17 8.1 38.4 14.3 62.5 18.2-2.6 16.4-4.2 33.9-4.6 51.9h-81c1.8-25.7 10-49.6 23.1-70.1zm126-64.6c10.7 0 22.6 14.5 31.7 38.8 3.1 8.2 5.8 17.2 8 26.9-12.8 1.3-26.1 2-39.7 2s-26.9-.7-39.7-2c2.2-9.7 4.9-18.7 8-26.9 9.1-24.3 20.9-38.8 31.7-38.8zm0 87.7c15 0 29.6-.8 43.6-2.2 2.5 15.5 4 32.1 4.4 49.3h-95.9c.4-17.2 1.9-33.8 4.4-49.3 13.8 1.5 28.5 2.2 43.5 2.2zm68 47c-.4-18-2-35.5-4.6-51.9 24.1-3.9 45.5-10.1 62.5-18.2 13.1 20.5 21.3 44.5 23 70.1h-80.9zm45.7-86.6c-14.8 6.5-33.3 11.6-54.1 14.9-2.5-11.2-5.6-21.8-9.2-31.3-5-13.4-10.9-24.3-17.4-32.7 32 7.4 60.1 24.9 80.7 49.1zm-146.8-49c-6.5 8.3-12.4 19.3-17.4 32.7-3.6 9.5-6.7 20.1-9.2 31.3-20.7-3.4-39.3-8.4-54.1-14.9 20.6-24.3 48.7-41.8 80.7-49.1zm-80.7 242.3c14.8-6.5 33.3-11.6 54.1-14.9 2.5 11.2 5.6 21.8 9.2 31.3 5 13.4 10.9 24.3 17.4 32.7-32-7.4-60.1-25-80.7-49.1zm146.8 49c6.5-8.3 12.4-19.3 17.4-32.7 3.6-9.5 6.7-20.1 9.2-31.3 20.7 3.4 39.3 8.4 54.1 14.9-20.6 24.2-48.7 41.8-80.7 49.1z"}})])
          )
        }
      }
    